import {
    styledTD, styledTH, styledTable,
} from 'components/Table/styles/TableView'

export const resultsTable = {
    ...styledTable,
    overflow: 'hidden',
}

export const resultsTableTH = {
    ...styledTH,
    '&:last-child': {textAlign: 'right'},
}

export const resultsTableTd = {
    ...styledTD,
    '&:first-child': {fontWeight: 'bold'},
    '&:last-child': {textAlign: 'right'},
    'padding': '$resultsTableCellPaddingVertical $resultsTableCellPaddingHorizontal',
    'verticalAlign': 'center',
}

export const resultsTableHeaderTd = {
    borderBottom: '1px solid $tableBorder',
    padding: '$resultsTableCellPaddingVertical $resultsTableCellPaddingHorizontal',
}
